{
  "branding": {
    "frontdesk-attribution": "د FrontDesk+ په مرسته",
    "practice-logo": "د {{name}} نښان"
  },
  "validation": {
    "required": "دا برخه اړینه ده",
    "invalid-url": "مهرباني وکړئ یو سم URL ولیکئ",
    "pin-too-short": "PIN باید لږ تر لږه ۴ توري ولري",
    "pin-default-rejected": "معیاري PIN 0000 اجازه نلري. مهرباني وکړئ خپل PIN وټاکئ.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "شاته",
    "next": "بل",
    "cancel": "لغوه",
    "confirm": "تایید",
    "done": "بشپړ",
    "retry": "بیا هڅه وکړئ",
    "clear": "پاکول",
    "close": "تړل",
    "verifying": "تاییدېږي...",
    "select": "غوره کول",
    "minutes": "دقیقې",
    "clock": "",
    "gender": {
      "M": "نارینه",
      "W": "ښځینه",
      "D": "متنوع",
      "U": "نامعلوم"
    },
    "insurance": {
      "GKV": "قانوني بیمه",
      "PKV": "شخصي بیمه",
      "SELFPAY": "خپله تادیه"
    },
    "scroll-up": "پورته سکرول",
    "scroll-down": "ښکته سکرول"
  },
  "settings": {
    "device-reset": {
      "title": "وسیله بیا تنظیم کړئ",
      "description": "له دې وسیلې څخه د کلینیک اړیکه، د وسیلې تنظیمات او PIN لرې کړئ.",
      "confirmation": "دا وسیله باید بیا تنظیم شي. د SOL تنظیمات او په inSuite کې د ناروغانو معلومات نه بدلېږي.",
      "cancel": "لغوه کول",
      "confirm": "اوس بیا تنظیم کړئ"
    },
    "title": "تنظیمات",
    "save": "خوندي کول",
    "save-success": "تنظیمات خوندي شول",
    "save-error": "تنظیمات خوندي نه شول",
    "load-error": "تنظیمات پورته نه شول",
    "pin": {
      "title": "PIN ته اړتیا ده",
      "description": "تنظیماتو ته د لاسرسي لپاره خپل PIN ولیکئ.",
      "error": "ناسم PIN. مهرباني وکړئ بیا هڅه وکړئ.",
      "backspace": "وروستۍ شمېره پاکه کړئ"
    },
    "connection": {
      "title": "اړیکه",
      "description": "د Doc-Cirrus Bridge سرور لپاره د اتصال ترتیبات",
      "bridge-url": "Bridge URL",
      "device-name": "د وسیلې نوم",
      "device-name-placeholder": "د مثال په توګه استقبال، 1 خونه، کیوسک",
      "device-name-hint": "په Bridge ډشبورډ کې د پیژندنې لپاره نوم",
      "kim-address": "د KIM پته (اختیاري)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "ازموینه",
      "success": "اړیکه بریالۍ شوه",
      "error": "اړیکه ناکامه شوه",
      "api-unreachable": "DocCirrus API ته لاسرسی نشته",
      "status-title": "د اړیکې حالت",
      "status": {
        "api": "API وصل دی",
        "ti": "ټیلیماتیک زیربنا",
        "card-reader": "د کارت لوستونکی شته",
        "medical-card": "د کلینیک کارت (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol ټوکن (له inSuite څخه)",
      "sol-token-hint": "په inSuite کې د Bridge له مدیریت څخه یې کاپي کړئ. د اړیکې لپاره اړین دی.",
      "sol-token-show": "ټوکن ښکاره کړئ",
      "sol-token-hide": "ټوکن پټ کړئ",
      "bridge-unreachable": "Bridge ته لاسرسی نشته. مهرباني وکړئ پته او پورټ وګورئ.",
      "diagnostic-id": "د تشخیص پېژند: {{id}}",
      "scan-qr": "QR کوډ سکین کړئ",
      "scan-title": "د Bridge QR کوډ سکین کړئ",
      "scan-manual": "په لاس دننه کړئ"
    },
    "terminal": {
      "title": "د کارت لوستونکی",
      "description": "د ټیلیمیټکس زیربنا لپاره د کارت لوستونکي انتخاب",
      "select": "ترمینل غوره کړئ",
      "select-placeholder": "ترمینل غوره کړئ...",
      "loading": "ترمینلونه پورته کېږي...",
      "none-available": "ترمینل نشته",
      "none-found": "ترمینل ونه موندل شو",
      "found": "{{count}} ترمینل(ونه) وموندل شول",
      "connect-hint": "د ترمینلونو بارولو لپاره لومړی د برج سرور سره وصل شئ.",
      "found-count": "موندل شوي کارت لوستونکي: {{count}}",
      "refresh": "کارت لوستونکي بیا راوړئ"
    },
    "practice": {
      "title": "کلینیک",
      "description": "ستاسو د کلینیک په اړه معلومات",
      "name": "د کلینیک نوم",
      "name-placeholder": "د مثال په توګه ډاکټر جان سمیټ",
      "welcome-message": "د ښه راغلاست پیغام",
      "welcome-placeholder": "لکه: زموږ کلینیک ته ښه راغلاست",
      "scheduler-available": "د وخت نیولو سیستم فعال کړئ",
      "scheduler-available-description": "ناروغانو ته اجازه ورکړئ چې د ځان خدمت ټرمینل له لارې ملاقاتونه بک کړي",
      "prescription-available": "د نسخې خدمت فعال کړئ",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "خالي یې پرېږدئ چې ښه راغلاست د ناروغ په ژبه وښودل شي. ستاسو خپل متن په هره ژبه کې بې له بدلون ښودل کېږي."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "د ټولو وسیلو لپاره خوندي شو په {{value}}",
      "never-saved-default": "تلواله ترتیب، تر اوسه نه دی بدل شوی."
    },
    "anamnesis": {
      "title": "ډیجیټل طبي تاریخچه",
      "description": "یو لینک او QR کوډ ښیې ستاسو د طبي تاریخ چمتو کونکي ته د چیک ان څخه وروسته.",
      "enabled": "د چیک ان څخه وروسته د طبي تاریخ لینک ښکاره کړئ",
      "enabled-description": "د بشپړ چیک ان وروسته ستاسو د طبي تاریخ چمتو کونکي ته لینک او QR کوډ ښیې، د مثال په توګه Nelly.",
      "url": "د طبي تاریخچې د چمتو کوونکي لینک",
      "url-hint": "لینک د ټولو ناروغانو لپاره جامد او ورته دی.",
      "preview-label": "د بشپړتیا سکرین مخکتنه",
      "preview-note": "لینک د ټولو ناروغانو لپاره جامد او ورته دی.",
      "url-first": "د فعالولو لپاره لومړی یو سم لینک دننه کړئ."
    },
    "appearance": {
      "title": "بڼه",
      "description": "د کارن انٹرفېس بدل کړئ",
      "language": "ژبه",
      "default-kiosk-language": "د ناروغ اصلي ژبه",
      "default-kiosk-language-hint": "هغه ژبه چې د نوي کیوسک ناستې د ناروغانو لپاره پیل کیږي.",
      "voice-over-volume": "د غږیز لارښود کچه",
      "voice-over-hint": "د لاسرسي لپاره د غږ پورته کولو معاون حجم کنټرولوي.",
      "language-first": "د ناستې په پیل کې د ژبې ټاکنه وښایئ"
    },
    "security": {
      "title": "امنیت",
      "description": "تنظیماتو ته د لاسرسي PIN",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "د کیوسک مدیریت",
    "nav": {
      "general": "عمومي",
      "flows": "دندې",
      "anamnese": "ډیجیټل طبي تاریخچه",
      "device": "وسیله او اړیکه"
    },
    "flows": {
      "title": "په ټرمینل کې دندې"
    },
    "language": {
      "title": "ژبه او په غږ لوستل",
      "description": "په دې وسیله کې د ناروغانو لپاره ژبه او په غږ لوستل."
    }
  },
  "self-service": {
    "title": "خپلواک خدمت",
    "step-progress": "ګام {{current}} / {{total}}",
    "flows": {
      "checkin": "حاضري ثبتول",
      "scheduler": "وخت نیول",
      "prescription": "نسخې",
      "locations": "د ځای نقشه",
      "emergency": "بیړنی حالت"
    },
    "audio-guide": {
      "on": "غږ فعال",
      "off": "غږ بند",
      "replay": "لارښونه بیا غږول",
      "replay-unavailable": "د بیا غږولو لپاره غږیزه لارښونه نشته"
    },
    "language-selector": {
      "title": "ژبه غوره کړئ",
      "description": "مهرباني وکړئ خپله غوره ژبه وټاکئ"
    },
    "settings": "تنظیمات",
    "start": {
      "welcome": "ښه راغلاست",
      "subtitle": "مهرباني وکړئ یو انتخاب وکړئ",
      "check-in-label": "اصلي لار",
      "check-in-cta": "حاضري ثبتول",
      "check-in-description": "وخت مو مخکې نیولی؟ دلته حاضري ثبت کړئ.",
      "check-in-hint": "خپل کارت چمتو وساتئ",
      "scheduler-label": "نوی",
      "scheduler-cta": "وخت ونیسئ",
      "scheduler-description": "نوی ملاقات وټاکئ.",
      "location-plan": "د ځای نقشه",
      "location-plan-description": "د درملنې خونې ته لاره ومومئ.",
      "prescription-label": "نسخه",
      "prescription-cta": "نسخې او غوښتنې",
      "prescription-description": "نسخې وګورئ یا د بیا غوښتنې امر وکړئ.",
      "emergency-cta": "ځايي بیړنی خبرداری",
      "emergency-description": "یوازې په دې وسیله غږېږي او مرسته نه راغواړي.",
      "tap-to-start": "د پیل لپاره لمس کړئ"
    },
    "offline": {
      "banner-title": "حاضري ثبتول لنډمهاله نشته",
      "banner-message": "مهرباني وکړئ د مرستې لپاره له منشي سره خبرې وکړئ.",
      "emergency-available": "ځايي خبرداری لا هم شته. دا مرسته نه راغواړي.",
      "flow-disabled": "لنډمهاله نشته"
    },
    "readability": {
      "toggle-label": "د لوستلو حالت",
      "on": "د لوستلو حالت",
      "off": "د لوستلو حالت"
    },
    "reset-overlay": {
      "timeout-title": "ناسته پای ته ورسېده",
      "timeout-subtitle": "ستاسو وخت پای ته رسېدلی. ستاسو معلومات خوندي دي.",
      "offline-title": "اړیکه پرې شوه",
      "offline-subtitle": "اړیکه پرې شوه. مهرباني وکړئ له منشي سره خبرې وکړئ.",
      "interruption-title": "ناسته پای ته ورسېده",
      "interruption-subtitle": "ستاسو ناسته په خوندي ډول پای ته ورسېده.",
      "completion-title": "مننه!",
      "completion-subtitle": "ستاسو غوښتنه په بریالیتوب بشپړه شوه.",
      "reassurance": "ستاسو شخصي معلومات په دې وسیله کې نه ساتل کېږي.",
      "auto-dismiss": "په {{seconds}} ثانیو کې پیل ته ستنېږي...",
      "dismiss": "پیل ته لاړ شئ"
    },
    "timed-terminal": {
      "countdown": "په {{seconds}} ثانیو کې اتومات ستنېدل",
      "countdown-outcome": "دا ترمینل به په اتومات ډول د پیل پردې ته ستون شي.",
      "more-time": "نور وخت",
      "extended": "وخت زیات شو"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "دا پوښتنې ستاسو په ژبه کې نشته. مهرباني وکړئ له وړاندې شوو ژبو یوه وټاکئ یا د پذیرش څانګې ته ورشئ.",
        "alternatives": "بدیل وختونه",
        "loading": "پوښتنې بارول کېږي…",
        "reception-fallback": "مهرباني وکړئ منشي ته ورشئ.",
        "error-title": "پوښتنې پورته نه شوې",
        "language-unavailable-lead": "دا پوښتنې ستاسو په ژبه نشته.",
        "language-unavailable-title": "مهرباني وکړئ له دې ژبو یوه وټاکئ",
        "language-unavailable-body": "یا له منشي مرسته وغواړئ."
      },
      "start": {
        "title": "د ملاقات وخت نیول",
        "subtitle": "په څو ګامونو کې خپل مناسب ملاقات وټاکئ",
        "welcome": "د ملاقات وخت نیولو ته ښه راغلاست",
        "description": "موږ به تاسو ته د بکینګ پروسې له لارې لارښوونه وکړو",
        "cta": "اوس د ملاقات وخت ونیسئ"
      },
      "patient-id": {
        "title": "پیژندنه",
        "subtitle": "مهرباني وکړئ خپل ځان وپیژنئ",
        "mode-card": "د کارت سره",
        "mode-search": "لټون",
        "mode-create": "نوی جوړ کړئ",
        "insert-card": "مهرباني وکړئ خپل د بیمې کارت دننه کړئ",
        "reading-card": "د کارت لوستل...",
        "simulate-card": "کارت ازمایښتي ولولئ",
        "multiple-matches": "ډیری ناروغان وموندل شول. د کارت ډیټا کارول.",
        "search-placeholder": "نوم یا د بیمې شمیره...",
        "searching": "لټون روان دی...",
        "no-results": "هیڅ پایله ونه موندل شوه",
        "first-name": "لومړی نوم",
        "last-name": "تخلص",
        "dob": "د زيږون نیټه",
        "insurance": "بیمه",
        "continue": "دوام ورکړئ",
        "creating": "ناروغ جوړېږي...",
        "patient-created": "ناروغ په بریالیتوب سره جوړ شو!",
        "create-error": "ناروغ جوړ نه شو."
      },
      "appointment-type": {
        "title": "د ملاقات ډول وټاکئ",
        "subtitle": "مهرباني وکړئ د خپلې لیدنې دلیل غوره کړئ",
        "loading": "د ملاقات ډولونه پورته کیږي...",
        "no-types": "د ملاقات ډولونه نشته",
        "error": "د ملاقات ډولونه پورته نه شول. مهرباني وکړئ بیا هڅه وکړئ.",
        "no-bookable": "دا د ملاقات ډولونه اوس له کیوسک څخه نه شي نیول کېدای. مهرباني وکړئ د ثبت مېز ته ورشئ یا د تلیفون له لارې وخت واخلئ.",
        "disabled-default": "مهرباني وکړئ دا ملاقات مستقیم د ثبت په مېز یا د تلیفون له لارې وټاکئ.",
        "disabled-footer": "یوازې ثبت مېز/تلیفون",
        "lead": "کوم ډول وخت غواړئ بک کړئ؟",
        "duration": "شاوخوا {{minutes}} دقیقې",
        "empty-title": "دلته اوس وخت نه شي بک کېدای",
        "none-bookable-title": "دا وختونه دلته نه شئ بک کولی",
        "none-bookable-body": "مهرباني وکړئ له منشي وپوښتئ یا موږ ته زنګ ووهئ."
      },
      "types": {
        "general": "عمومي سلا مشوره",
        "general-desc": "د عمومي شکایتونو او پوښتنو لپاره",
        "checkup": "د ناروغیو د مخنیوي لپاره معاینه",
        "checkup-desc": "منظم روغتیا معاینات",
        "vaccination": "واکسیناسيون",
        "vaccination-desc": "د واکسین وخت تنظیم کړئ",
        "followup": "تعقیب کړئ",
        "followup-desc": "ليدژمنه کنټرول کړئ",
        "prescription": "تجويز يا مشوره",
        "prescription-desc": "د نسخې اوچتونه"
      },
      "slot-selection": {
        "title": "ملاقات وټاکئ",
        "subtitle": "مهرباني وکړئ د ملاقات لپاره موجوده وخت وټاکئ",
        "loading": "موجوده لیدني باريږي...",
        "no-slots": "هیڅ ملاقات شتون نلري:",
        "no-appointment-type": "د ملاقات ډول نه دی ټاکل شوی",
        "error": "شته سلاټونه نشي پورته کولی. مهرباني وکړئ بیا هڅه وکړئ.",
        "quick-select": "راتلونکې موجوده ملاقاتونه:",
        "select-date": "یا یوه نیټه وټاکئ:",
        "times-for": "{{date}}",
        "available": "شته",
        "unavailable": "سلاټونه نشته",
        "slots": "سلاټونه",
        "select-time-hint": "د خپل ملاقات وخت ټاکلو لپاره ټایپ کړئ",
        "week-short": "Wk",
        "weekday-mon": "دوشنبه",
        "weekday-tue": "سې شنبه",
        "weekday-wed": "چهارشنبه",
        "weekday-thu": "پنجشنبه",
        "weekday-fri": "جمعه",
        "weekday-sat": "شنبه",
        "weekday-sun": "ی.",
        "period-morning": "سهار",
        "period-midday": "مازدیګری",
        "period-afternoon": "غرمه",
        "period-evening": "ماښام",
        "period-morning-short": "مخکې له غرمې",
        "period-midday-short": "غرمه",
        "period-afternoon-short": "وروسته له غرمې",
        "period-evening-short": "ماښام",
        "period-dots-legend": "د وخت شتون",
        "filter-hint": "د غوره وختونو لخوا فلټر کړئ:",
        "or-choose-below": "یا لاندې انتخاب وکړئ",
        "no-slots-period": "سلاټونه نشته",
        "show-all": "ټول ښکاره کړه",
        "free": "وړيا",
        "your-selection": "ستاسو انتخاب.",
        "oclock": "بجې",
        "choose-slot": "سلاټ غوره کړئ",
        "choose-day": "ورځ وټاکئ",
        "choose-day-first": "مهرباني وکړئ لومړی یوه ورځ وټاکئ",
        "times-heading": "په {{date}} خالي وختونه",
        "time-value": "{{time}}",
        "empty-title": "په {{month}} کې خالي وخت نشته",
        "empty-body": "راتلونکې میاشت وګورئ یا له منشي وپوښتئ – په خوښۍ مرسته کوو.",
        "next-month": "راتلونکې میاشت",
        "previous-month": "تېره میاشت"
      },
      "confirmation": {
        "patient-responses": "ستاسو ځوابونه",
        "review-loading": "لنډیز کتل کېږي…",
        "review-unavailable": "لنډیز شتون نه لري. مهرباني وکړئ بیا هڅه وکړئ یا له منشي وپوښتئ.",
        "check-booking": "د وخت نیولو حالت وګورئ",
        "title": "ملاقات تایید کړئ",
        "subtitle": "مهرباني وکړئ خپل د ثبتولو بیاکتنه وکړئ",
        "patient": "ناروغ",
        "datetime": "نيټه او وخت",
        "booking": "بک کول",
        "confirm": "د ليدنې وخت ثبت کړئ",
        "heading": "ایا دا سم ښکاري ؟",
        "lead": "مهرباني وکړئ خپل ملاقات تایید کړئ.",
        "appointment": "ټاکنه",
        "insured-via": "له لارې بیمه شوی",
        "description-label": "د کلینیک لپاره یادښتونه (اختیاري)",
        "description-hint": "که د ملاقات د وخت نیولو یا حاضري ثبتولو پر مهال کوم څه باید په پام کې ونیسو، موږ ته یې ولیکئ.",
        "description-placeholder": "لکه: د تګ راتګ محدودیت، ملګری کس، مهم یادښتونه",
        "description-too-long": "مهرباني وکړئ یادښت تر ۵۰۰ تورو پورې لنډ کړئ.",
        "summary": "لنډيز",
        "change": "بدلون",
        "book-binding": "د ليدنې وخت ثبت کړئ",
        "cancel": "لغوه کړل",
        "type-label": "د وخت ډول",
        "datetime-value": "{{date}} په {{time}}",
        "name-label": "نوم",
        "insurance-label": "بیمه",
        "insurance-GKV": "قانوني روغتیا بیمه",
        "insurance-PKV": "خصوصي روغتیا بیمه",
        "insurance-SELFPAY": "پخپله تادیه کوونکی",
        "change-time": "وخت بدل کړئ",
        "description-free-text": "نورې یادونې (اختیاري)",
        "note-wheelchair": "زه ویلچیر کاروم",
        "note-companion": "زه له ملګري سره راځم",
        "note-interpreter": "ژباړونکي ته اړتیا لرم"
      },
      "done": {
        "title": "ليدژمنه ثبت شوه!",
        "label": "ثبت شو",
        "subtitle": "ستاسو لیدنه په بریالیتوب سره ثبت شوه.",
        "date": "نیټه",
        "time": "وخت",
        "booking-id": "د بک کولو شمیره",
        "qr-hint": "په خپل جنتري کې اضافه کړئ",
        "qr-description": "دا QR کوډ د خپل سمارټ فون کیمرې سره سکین کړئ ترڅو خپل تقویم ایپلیکیشن کې د ملاقات وخت اضافه کړئ",
        "auto-redirect": "تاسو به په لنډ وخت کې د پیل پاڼې ته واستول شئ...",
        "auto-redirect-countdown": "د {{seconds}} ثانیو کې پیل کولو لپاره بیرته راستنیدنه...",
        "back-to-start": "بېرته پیل ته",
        "print-button": "د ملاقات پاڼه چاپ کړئ",
        "print-preparing": "د چاپ مخ چمتو کېږي…",
        "print-error": "د ملاقات پاڼه خلاصه نه شوه. مهرباني وکړئ بیا هڅه وکړئ یا له استقبالیې څخه مرسته وغواړئ.",
        "print-returned": "د سیسټم د چاپ مخ وتړل شو. که اړتیا وي بله کاپي غوښتلی شئ.",
        "print-title": "ستاسو ملاقات",
        "print-location": "ځای",
        "print-map-hint": "ځای په خپل ټیلیفون کې پرانیزئ",
        "print-error-v2": "د وخت پاڼه پرانیستل نه شوه. مهرباني وکړئ بیا هڅه وکړئ یا له منشي وپوښتئ."
      },
      "error": {
        "assistance-info": "موږ ونه شو کولی ستاسو بکنګ تایید کړو. کېدای شي ستاسو وخت دمخه بک شوی وي. مهرباني وکړئ له منشي وپوښتئ.",
        "pending-title": "بکنګ تایید نه شو",
        "pending-info": "موږ ونه شو کولی ستاسو بکنګ تایید کړو. کېدای شي ستاسو وخت دمخه بک شوی وي. مهرباني وکړئ بیا وګورئ یا له منشي وپوښتئ.",
        "title": "بک کول ناکام شول",
        "subtitle": "ليدژمنه نشي بک کیدی.",
        "info": "مهرباني وکړئ بیا هڅه وکړئ یا له منشي وپوښتئ."
      },
      "phase": {
        "identify": "ننوتل",
        "choose": "د وخت ټاکل",
        "confirm": "تایید"
      }
    },
    "prescription": {
      "start": {
        "title": "نسخې او امر کول",
        "subtitle": "د پخوانۍ نسخو یا د بیا ډکولو غوښتنه کولو لپاره خپل د بیمې کارت دننه کړئ.",
        "button": "کارت دننه کړئ"
      },
      "card-check": {
        "loading": "د کارت لوستونکی پورته کول...",
        "no-terminal": "د کارت لوستونکی ندی تنظیم شوی",
        "no-terminal-hint": "مهرباني وکړئ د مرستې لپاره کارمندانو سره اړیکه ونیسئ.",
        "insert-card": "مهرباني وکړئ خپل کارت دننه کړئ",
        "insert-card-hint": "خپل د بیمې کارت لوستونکي ته دننه کړئ.",
        "card-detected": "کارت وموندل شو",
        "reading": "د کارت لوستل...",
        "reading-hint": "یوه دقیقه صبر وکړی",
        "error": "د کارت په لوستلو کې تېروتنه",
        "retry": "بیا کوښښ وکړئ.",
        "manual-lookup": "پرته له کارت څخه دوام ورکړئ",
        "load-error": "د کارت لوستونکی نشي پورته کولی",
        "read-error": "کارت نشي لوستل کیدی"
      },
      "patient-selection": {
        "title": "ناروغ وټاکئ",
        "subtitle": "ډیری ناروغان وموندل شول. مهرباني وکړئ خپل نوم وټاکئ.",
        "try-again": "بیا کوښښ وکړئ.",
        "try-again-hint": "کارت بیا دننه کړئ"
      },
      "list": {
        "title": "ستاسو نسخې",
        "for-patient": "د {{name}} لپاره نسخې",
        "loading": "نسخې پورته کول...",
        "error-title": "د تېروتنې په پورته کولو کې",
        "fetch-error": "نسخې نشي پورته کیدی",
        "back-home": "بېرته پیل ته",
        "done": "وشو"
      },
      "detail": {
        "prescription-info": "د نسخې معلومات",
        "date": "نیټه",
        "prescriber": "د نسخې لیکونکی",
        "comment": "یادونه",
        "medications": "درملنه:",
        "form": "فرم",
        "pack-size": "د بنډل اندازه",
        "manufacturer": "جوړونکی",
        "loading": "د نسخې پورته کول...",
        "fetch-error": "د نسخې توضیحات نشي پورته کیدی",
        "back-to-list": "بیرته لیست ته",
        "print": "پرنټ"
      },
      "types": {
        "public": "عامه نسخه",
        "private": "شخصي نسخه",
        "long-term": "اوږدمهاله نسخه",
        "btm": "د مخدره توکو نسخه",
        "g": "شنه نسخه",
        "t": "T- نسخه"
      },
      "no-patient": {
        "title": "ناروغ ونه موندل شو",
        "subtitle": "له بده مرغه، د دې کارت لپاره هیڅ ناروغ ونه موندل شو. مهرباني وکړئ د مرستې لپاره کارمندانو سره اړیکه ونیسئ.",
        "try-again": "بیا هڅه وکړئ",
        "back-home": "بیرته پیل ته",
        "title-v2": "ورته معلومات ونه موندل شول",
        "subtitle-v2": "موږ تاسو ونه موندئ. مهرباني وکړئ بیا هڅه وکړئ یا له منشي وپوښتئ."
      },
      "done": {
        "title": "له تاسو مننه",
        "subtitle": "تاسو کولی شئ اوس څوکۍ ونیسئ. که تاسو پوښتنې لرئ، مهرباني وکړئ د کارمندانو سره اړیکه ونیسئ.",
        "no-prescriptions-title": "په فایل کې هیڅ نسخه نشته",
        "no-prescriptions-subtitle": "موږ ستاسو لپاره هیڅ فعال نسخه نشو موندلی. که تاسو تمه لرئ، مهرباني وکړئ د استوګنې کارمندانو سره اړیکه ونیسئ.",
        "error-title": "یوه تېروتنه رامنځته شوه",
        "error-subtitle": "مهرباني وکړئ د نورو مرستې لپاره کارمندانو سره اړیکه ونیسئ.",
        "auto-redirect": "په {{seconds}} ثانیو کې اتوماتیک لارښود",
        "finish": "بیرته پیل ته"
      },
      "hub": {
        "title": "ستاسو نسخې",
        "for-patient": "د {{name}} لپاره نسخې",
        "loading": "نسخې پورته کول...",
        "error-title": "د تېروتنې په پورته کولو کې",
        "fetch-error": "نسخې نشي پورته کولی",
        "back-home": "بیرته پیل ته",
        "done": "وشو",
        "order-button": "د سپارښتنی نسخه",
        "existing-prescriptions": "ستاسو اوسنۍ نسخې",
        "no-prescriptions": "هیڅ فعاله نسخې ونه موندل شوې."
      },
      "patient-lookup": {
        "title": "ناروغ ومومئ",
        "subtitle": "خپل د زیږون نیټه دننه کړئ",
        "last-name": "د نوم وروستی ټکی",
        "first-name": "د نوم لومړی ټکی",
        "date-of-birth": "د زیږون نیټه",
        "lastname": "د نوم وروستی ټکی",
        "lastname-placeholder": "ستاسو وروستی نوم",
        "firstname": "د نوم لومړی ټکی",
        "firstname-placeholder": "لومړی نوم",
        "dob": "د زیږون نیټه",
        "search": "لټون",
        "searching": "لټون روان دی...",
        "search-error": "د لټون تېروتنه: {{message}}",
        "no-match": "هیڅ ناروغ ونه موندل شو. مهرباني وکړئ خپل معلومات وګورئ.",
        "error": "د لټون تېروتنه. مهرباني وکړئ بیا هڅه وکړئ.",
        "found": "ناروغ وموندل شو",
        "confirm": "رښتینی کړه",
        "ambiguous": "ډیری میچونه",
        "ambiguous-hint-firstname": "مهرباني وکړئ د لټون ښه کولو لپاره خپل لومړی نوم هم دننه کړئ.",
        "ambiguous-hint-additional": "مهرباني وکړئ خپل معلومات یا د تماس کارمندان وګورئ.",
        "not-found": "ناروغ ونه موندل شو",
        "not-found-hint": "په دې توضیحاتو کې هیڅ ناروغ ونه موندل شو.",
        "not-found-action": "بیا کوښښ وکړئ."
      },
      "manual-identification": {
        "unverified": "ستاسو هویت د روغتیا بیمې په کارت نه دی تایید شوی. کلینیک به د غوښتنې له پروسس مخکې ستاسو معلومات او غوښتنه وڅېړي."
      },
      "medication-selection": {
        "title": "د نسخې غوښتنه وکړئ",
        "subtitle": "د ډاکټر دفتر ستاسو غوښتنې بیاکتنه کوي. یوځل چې تصویب شو، eRx ستاسو په e-prescription کاریال کې چمتو دی.",
        "back": "شا ته",
        "submit": "بیاکتنې ته دوام ورکړئ",
        "reason-title": "تاسو نسخې ته ولې اړتیا لرئ ؟",
        "reason-hint": "کلینیک سره مرسته کوي چې ستاسو غوښتنه وارزوي.",
        "reason-validation": "مهرباني وکړئ یو دلیل غوره کړئ.",
        "reason-schmerzen": "درد",
        "reason-entzuendung": "سوزش",
        "reason-nachsorge": "د جراحي / عملیاتو وروسته",
        "reason-allergie": "الرجی / عکس العمل",
        "reason-chronisch": "مزمن حالت",
        "reason-anderes": "بل څه",
        "medications-title": "کوم درمل ؟",
        "request-hint": "تشریح کړئ چې تاسو څه ته اړتیا لرئ، یا هغه پخوانۍ نسخې ولیکئ چې تاسو یې نوي کول غواړئ.",
        "request-placeholder": "د مثال په توګه Ibuprofen 600 ملی ګرامه، د وروستي ځل په څیر",
        "request-validation": "مهرباني وکړئ تشریح کړئ چې کوم درمل ته اړتیا لرئ.",
        "history-title": "پخوانۍ نسخې",
        "history-hint": "د خپلې غوښتنې غوره کولو لپاره یوه لیکنه اضافه کړئ.",
        "history-loading": "مخکینۍ نسخې پورته کول...",
        "history-error": "پخوانۍ نسخې نشي بار کیدی.",
        "history-add": "جمع",
        "history-added": "اضافه شوی دی",
        "history-date": "وروستی: {{date}}",
        "history-request-line": "نوي کول: {{medicationName}}",
        "urgency-title": "دا څومره عاجل دی ؟",
        "urgency-hint": "کلینیک سره مرسته کوي چې غوښتنې ته لومړیتوب ورکړي.",
        "urgency-soon": "بيړني",
        "urgency-soon-meta": "چې څومره زر ممکن وي",
        "urgency-tomorrow": "ژر",
        "urgency-tomorrow-meta": "په راتلونکو څو ورځو کې",
        "urgency-week": "دا اونۍ",
        "urgency-week-meta": "د وخت فشار نشته",
        "lead": "کلینیک ستاسو غوښتنه کتنه کوي. له منظورۍ وروسته به خپل برېښنايي نسخه د برېښنايي نسخې په اپ کې یا ستاسو د روغتیا بیمې په کارت کې ومومئ.",
        "history-hint-v2": "د زیاتولو لپاره پخوانۍ نسخې ته ټک ورکړئ.",
        "history-retry": "بیا پورته کړئ"
      },
      "request-review": {
        "title": "د امر بیاکتنه",
        "subtitle": "مهرباني وکړئ د خپلې نسخې غوښتنې بیاکتنه وکړئ.",
        "request-label": "غوښتل شوي درمل",
        "selected-medications": "ټاکل شوي درملونه",
        "free-text-medications": "اضافي درمل",
        "freetext-label": "نور",
        "quarterly-warning": "ستاسو د بیمې کارت پدې ربعه کې ندی لوستل شوی. د ډاکټر دفتر ممکن تاسو سره اړیکه ونیسي.",
        "egk-warning": "ستاسو د بیمې کارت پدې ربعه کې ندی لوستل شوی. د ډاکټر دفتر ممکن تاسو سره اړیکه ونیسي.",
        "submit": "وسپارئ",
        "submitting": "سپارښتنه کیږي...",
        "submit-error": "غوښتنه مو وسپارئ. مهرباني وکړئ بیا هڅه وکړئ.",
        "back": "شا ته",
        "reason-label": "سبب يې",
        "urgency-label": "بیړنی",
        "completion-email-choice": "کله چې کلینیک زما غوښتنه بشپړه کړي، غواړم برېښنالیک ترلاسه کړم.",
        "completion-email-label": "برېښنالیک پته",
        "completion-email-placeholder": "name@example.com",
        "completion-email-hint": "یوازې د دې یو ځل پیغام لپاره. پته په اصلي معلوماتو کې نه ساتل کېږي.",
        "completion-email-invalid": "مهرباني وکړئ سمه برېښنالیک پته ولیکئ.",
        "egk-proof-required": "د نسخې غوښتنې یوازې د بیمې کارت له بریالي لوستلو وروسته ممکنې دي. مهرباني وکړئ له کارکوونکو سره اړیکه ونیسئ.",
        "title-v2": "غوښتنه وګورئ",
        "completion-email-hint-v2": "پته یوازې د همدې یو پیغام لپاره کارول کېږي."
      },
      "confirmation": {
        "title": "غوښتنه وليږل شوه",
        "subtitle": "ستاسو د نسخې غوښتنه په بریالیتوب سره وسپارل شوه.",
        "success-title": "غوښتنه وليږل شوه",
        "success-subtitle": "ستاسو د نسخې غوښتنه په بریالیتوب سره وسپارل شوه.",
        "estimated-time": "ستاسو نسخه به نږدې {{time}} کې چمتو وي.",
        "info": "تاسو کولی شئ د خپلې بیمې کارت یا eRezept کاریال سره په درملتون کې خپله نسخه واخلئ.",
        "auto-redirect": "په {{seconds}} ثانیو کې اتوماتیک لارښود",
        "back-to-start": "بیرته پیل ته",
        "handling-label": "Handled by the practice",
        "next-steps": "کلینیک ستاسو غوښتنه کتنه کوي. له منظورۍ وروسته کولی شئ خپله برېښنايي نسخه په درملتون کې د روغتیا بیمې کارت یا د برېښنايي نسخې اپ سره ترلاسه کړئ."
      },
      "phase": {
        "identify": "ننوتل",
        "request": "غوښتنه",
        "review": "کتنه"
      }
    },
    "check-in": {
      "flow-label": "حاضري ثبتول",
      "has-appointment": {
        "eyebrow": "ټاکنه",
        "title": "ایا تاسو د ملاقات وخت لرئ ؟",
        "subtitle": "د مهربانۍ له مخې غوراوی وټاکئ.",
        "yes-label": "هو",
        "yes": "ما معاېنې لپاره وخت اخیستی.",
        "yes-description": "زه غواړم زما د ملاقات لپاره چیک کړم.",
        "yes-hint": "تر ټولو چټکه لاره",
        "unsure-label": "کيدای شي",
        "unsure": "زه ډاډه نه یم",
        "unsure-description": "موږ به دا ستاسو لپاره وګورو.",
        "unsure-hint": "موږ به ستاسو لټون وکړو",
        "no-label": "نه",
        "no": "نه، بې وخته راغلی یم",
        "no-description": "زه لیدنه نه لرم.",
        "no-hint": "بې وخته مراجعه"
      },
      "card-check": {
        "eyebrow": "د بیمې کارت",
        "title": "د بیمې کارت ولولئ",
        "subtitle": "مهرباني وکړئ خپل د بیمې کارت لوستونکي ته دننه کړئ",
        "insert-title": "د بیمې کارت د کارت لوستونکي ته دننه کړئ.",
        "insert-detail": "موږ ستاسو توضیحات په اوتومات ډول ولوو — تاسو اړتیا نلرئ کوم بل څه ترسره کړئ.",
        "other-ways": "نورې لارې",
        "no-card-hint": "که تاسو همدا اوس خپل کارت له ځان سره نلرئ.",
        "pkv-hint": "د بیمې اپلیکیشن سره د QR کوډ وکاروئ.",
        "loading": "ترتیبات پورته کیږي...",
        "no-terminal": "د کارت لوستونکی ندی تنظیم شوی. مهرباني وکړئ کارمندانو سره اړیکه ونیسئ.",
        "checking": "د کارتونو چک کول...",
        "insert-prompt": "مهرباني وکړئ کارت دننه کړئ...",
        "card-detected": "کارت وموندل شو! لوستلو ته چمتو دی.",
        "read-card": "کارت ولولئ",
        "simulate-insert": "کارت ازمایښتي ولولئ",
        "reading": "د کارت لوستل...",
        "error": "کارت نشي لوستلی. مهرباني وکړئ بیا هڅه وکړئ.",
        "read-error": "د کارت ډیټا په لوستلو کې پاتې راغلی. مهرباني وکړئ بیا هڅه وکړئ.",
        "settings-error": "ترتیبات نشي پورته کولی. مهرباني وکړئ بیا هڅه وکړئ.",
        "no-card-prompt": "له ځانه سره کارت نشته ؟",
        "no-card-action": "لاسي لټون",
        "connection-warning": "د کارت لوستونکي سره د پیوستون ستونزې. مهرباني وکړئ انتظار وکړئ...",
        "pkv-prompt": "شخصي بیمه؟ Online Check-in",
        "pkv-instruction": "دا QR کوډ د خپل شخصي روغتیا بیمې اپلیکیشن سره سکین کړئ ترڅو ستاسو ډاټا په ډیجیټل ډول ولیږئ.",
        "pkv-continue": "لاسي ثبتولو ته دوام ورکړئ",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "مهرباني وکړئ بیا هڅه وکړئ یا پرته له کارت نوم ولیکئ. منشي په خوښۍ سره مرسته کوي.",
        "title-pkv": "د اپلیکیشن له لارې نوم لیکنه",
        "title-reading": "ستاسو کارت لوستل کېږي …",
        "title-unreadable": "کارت ونه لوستل شو",
        "title-no-terminal": "پرته له کارت نوم لیکنه",
        "no-terminal-body": "د کارت لوستونکی اوس شتون نه لري. مهرباني وکړئ پرته له کارت نوم ولیکئ یا منشي ته مراجعه وکړئ.",
        "reading-detail": "مهرباني وکړئ کارت په لوستونکي کې پرېږدئ. یوازې یوه شېبه نیسي.",
        "other-ways-title": "نورې لارې",
        "no-card-title": "پرته له کارت نوم لیکنه",
        "pkv-prompt-title": "شخصي بیمه لرئ؟",
        "pkv-prompt-hint": "ستاسو د شخصي روغتیایي بیمې د اپلیکیشن له لارې نوم لیکنه",
        "pkv-close": "بیا هم له کارت سره",
        "pkv-instruction-app": "د خپلې شخصي روغتیایي بیمې اپلیکیشن پرانیزئ او دا کوډ سکین کړئ. ستاسو معلومات به مستقیم موږ ته راشي."
      },
      "patient-selection": {
        "title": "پیژندنه اړینه ده",
        "subtitle": "ډیری ناروغان وموندل شول. مهرباني وکړئ خپل لومړی نوم دننه کړئ ترڅو موږ تاسو وپیژنو.",
        "firstname-label": "لومړی نوم",
        "firstname-placeholder": "د نوم لومړی ټکی ورکړه",
        "confirm-button": "رښتینی کړه",
        "no-match": "ورته ناروغ ونه موندل شو. مهرباني وکړئ د مرستې لپاره د هرکلي میز ته لاړ شئ.",
        "still-ambiguous": "ډیری میچونه پاتې دي. مهرباني وکړئ د مرستې لپاره د هرکلي میز ته لاړ شئ.",
        "select-error": "د ناروغ په پیژندلو کې پاتې راغلی. مهرباني وکړئ بیا هڅه وکړئ.",
        "staff-assist": "هرکلی ته لاړشئ",
        "title-v2": "لنډه پوښتنه",
        "subtitle-v2": "د ډاډ لپاره، مهرباني وکړئ خپل لومړی نوم ولیکئ.",
        "no-match-v2": "موږ تاسو په دې نوم ونه موندلئ. مهرباني وکړئ املا وګورئ یا منشي ته مراجعه وکړئ.",
        "still-ambiguous-v2": "موږ لا تر اوسه تاسو په ډاګه نه شو موندلی. مهرباني وکړئ منشي ته مراجعه وکړئ.",
        "select-error-v2": "له بده مرغه ونه شو. مهرباني وکړئ بیا هڅه وکړئ."
      },
      "card-checkin": {
        "title": "ننوتل تایید کړئ",
        "subtitle": "ستاسو معلومات په بریالیتوب سره ولوستل شول.",
        "confirm": "ننوتل تایید کړئ"
      },
      "register-from-card": {
        "title": "نوی نوم لیکنه",
        "subtitle": "موږ د کارت څخه ستاسو معلومات لوستلي دي. مهرباني وکړئ خپل راجسټریشن بیاکتنه او تایید کړئ.",
        "card-data": "د کارت معلومات",
        "create": "ناروغ راجستر کړئ",
        "create-error": "نوم لیکنه ناکامه شوه. مهرباني وکړئ بیا هڅه وکړئ یا د کارمندانو څخه د مرستې غوښتنه وکړئ.",
        "staff-assist": "کارمندانو ته زنګ ووهئ",
        "no-card-data-title": "د کارت معلومات نشته",
        "no-card-data": "ستاسو د کارت څخه د معلوماتو لوستلو توان نلري.",
        "insurance-verified": "بیمه تایید شوې: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "ستاسو معلومات له کارت څخه",
        "subtitle-v2": "مهرباني وکړئ خپل معلومات وګورئ. که څه سم نه وي، «بدلول» ټک کړئ.",
        "create-v2": "معلومات تایید کړئ",
        "create-error-v2": "له بده مرغه نوم لیکنه ونه شوه. بیا هڅه وکړئ یا منشي ته مراجعه وکړئ.",
        "insurer-missing-v2": "ستاسو په کارت کې د روغتیایي بیمې معلومات نشته. مهرباني وکړئ منشي ته مراجعه وکړئ.",
        "edit": "بدلول",
        "name": "نوم",
        "insurer": "روغتیایي بیمه"
      },
      "patient-lookup": {
        "title": "د ناروغ لټون",
        "subtitle": "مهرباني وکړئ خپل نوم یا د بیمې شمیره دننه کړئ.",
        "lastname": "تخلص",
        "lastname-placeholder": "ستاسو وروستی نوم",
        "dob": "د زيږون نیټه",
        "firstname": "لومړی نوم",
        "firstname-placeholder": "لومړی نوم",
        "search": "لټون",
        "searching": "لټون روان دی...",
        "search-placeholder": "نوم یا د بیمې شمیره...",
        "results-placeholder": "د لټون پایلې به دلته څرګند شي",
        "found": "ناروغ وموندل شو!",
        "confirm-identity": "مهرباني وکړئ تایید کړئ چې تاسو هغه ناروغ یاست چې ښودل شوی.",
        "confirm-button": "دا زه یم",
        "ambiguous-firstname": "ډیری ناروغان وموندل شول. مهرباني وکړئ خپل لومړی نوم دننه کړئ.",
        "ambiguous-additional": "ډیری ناروغان وموندل شول. مهرباني وکړئ کارمندانو سره اړیکه ونیسئ.",
        "disambiguation-hint": "دا موږ سره مرسته کوي چې تاسو په روښانه ډول وپیژنو.",
        "not-found": "د دې توضیحاتو سره هیڅ ناروغ ونه موندل شو.",
        "error": "د لټون تېروتنه: {{message}}",
        "staff-assist": "کارمندانو ته زنګ ووهئ",
        "not-found-prompt": "رالېښل شوی نه دی",
        "register-new": "نوی نوم لیکنه وکړئ",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "پرته له کارت نوم لیکنه",
        "subtitle-firstname": "مهرباني وکړئ خپل لومړی نوم هم ولیکئ.",
        "ambiguous-firstname-v2": "څو کسان دا تخلص لري. مهرباني وکړئ خپل لومړی نوم هم ولیکئ.",
        "search-again": "بیا لټون",
        "found-v2": "تاسو مو وموندلئ",
        "found-confirm": "مهرباني وکړئ په «دا زه یم» تایید کړئ.",
        "not-found-title": "تاسو مو ونه موندلئ",
        "not-found-check": "مهرباني وکړئ املا او د زېږون نېټه وګورئ. منشي په خوښۍ سره مرسته کوي.",
        "not-found-reception": "مهرباني وکړئ املا او د زېږون نېټه وګورئ یا منشي ته مراجعه وکړئ.",
        "ambiguous-additional-v2": "موږ تاسو په ډاګه نه شو موندلی. مهرباني وکړئ منشي ته مراجعه وکړئ.",
        "error-v2": "لټون اوس ونه شو. مهرباني وکړئ بیا هڅه وکړئ."
      },
      "checking-in": {
        "title": "یوه شیبه — موږ تاسو ګورو په.",
        "subtitle": "موږ تاسو د درملنې کتار کې اضافه کوو او ټیم ته خبر درکوو.",
        "step-insurance": "بیمه چیک شوې",
        "step-appointment": "ليدنه تایید شوي",
        "step-waitlist": "د انتظار لیست کې اضافه کول",
        "error": "چیک این ناکام شو. مهرباني وکړئ بیا هڅه وکړئ.",
        "continue": "پرمخبيول",
        "title-v2": "یوه شېبه صبر وکړئ",
        "loading": "ستاسو نوم لیکنه کېږي …",
        "subtitle-v2": "تاسو د انتظار په لست کې ثبتوو او ټیم ته خبر ورکوو.",
        "error-title": "له بده مرغه ونه شو",
        "error-v2": "ستاسو نوم لیکنه بشپړه نه شوه.",
        "error-body": "مهرباني وکړئ بیا هڅه وکړئ. که بیا هم ونه شو، منشي به مرسته وکړي."
      },
      "appointment-selection": {
        "title": "ملاقات وټاکئ",
        "subtitle": "تاسو نن ورځ ډیری لیدنې لرئ. مهرباني وکړئ یو غوره کړئ.",
        "checking-in": "چک کول...",
        "time": "{{time}}",
        "error-v2": "د دې وخت لپاره نوم لیکنه ونه شوه. بیا هڅه وکړئ یا منشي ته مراجعه وکړئ."
      },
      "no-appointment": {
        "title": "هیڅ ملاقات ونه موندل شو",
        "subtitle": "موږ نن ستاسو لپاره د ملاقات وخت نشو موندلی. مهرباني وکړئ منظم ملاقات وټاکئ.",
        "book-appointment": "د ملاقات وخت ونیسئ",
        "book-appointment-description": "د منظم مهالویش له لارې نوی ملاقات وټاکئ.",
        "staff-assist": "کارکوونکو ته زنګ ووهئ",
        "staff-assist-description": "زه مرستې ته اړتیا لرم.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "نن مو ستاسو لپاره کوم وخت ونه موند.",
        "book-v2": "نوی وخت ونیسئ",
        "book-v2-description": "اوس یو خالي وخت وټاکئ.",
        "have-appointment": "زه وخت لرم",
        "have-appointment-description": "منشي په خوښۍ سره مرسته کوي.",
        "unavailable-title": "مهرباني وکړئ وخت له منشي سره ونیسئ",
        "subtitle-unavailable": "نن مو ستاسو لپاره کوم وخت ونه موند. مهرباني وکړئ منشي ته مراجعه وکړئ."
      },
      "staff-assist": {
        "title": "کارمندان خبر کړل",
        "subtitle": "یو کارمند به ډیر ژر ستاسو سره مرسته وکړي.",
        "message": "مهرباني وکړئ دلته انتظار وکړئ. یو کارمند به ډیر ژر ستاسو سره وي.",
        "start-over": "بېرته پیل ته",
        "auto-redirect": "د {{seconds}} ثانیو کې پیل کولو لپاره بیرته راستنیدنه..."
      },
      "eeb-prompt": {
        "title": "بیمه تایید کړئ",
        "title-failed": "تایید ناکام شو.",
        "subtitle": "تاسو څنګه غواړئ خپل بیمه تایید کړئ ؟",
        "subtitle-failed": "د تایید غوښتنه کولو لپاره د خپل بیمې اپلیکیشن سره د QR کوډ سکین کړئ.",
        "verify-card": "په بریښنایی توګه تایید کړئ",
        "verify-card-description": "خپل د بیمې چمتو کونکي ته یوه غوښتنه واستوئ.",
        "select-insurer": "بیمه کوونکی وټاکئ",
        "select-insurer-description": "ستاسو د بیمه کونکي لاسي انتخاب.",
        "skip": "پرېږدئ",
        "eyebrow-chip": "انډوليز",
        "eyebrow": "چیک ان · د بیمې ثبوت (eEB)",
        "recommended": "وړاندیز شوی",
        "qr-title": "د خپل بیمې کاريال سره سکین کړئ",
        "qr-description": "خپل د روغتیا بیمې ایپ خلاص کړئ او کوډ سکین کړئ — eEB په مستقیم ډول موږ ته لیږل کیږي.",
        "qr-address-label": "...ته لېږل",
        "title-app": "د اپلیکیشن له لارې سند",
        "subtitle-app": "ستاسو بیمه کولی شي سند مستقیم موږ ته هم واستوي. کله چې بشپړ شو، «بل» ټک کړئ."
      },
      "quarterly-check": {
        "title": "د بیمې تایید",
        "checking": "موږ ستاسو د اوسني بیمې تایید ګورو...",
        "error": "دا چک ترسره نشو.",
        "title-v2": "ستاسو بیمه",
        "checking-v2": "ستاسو بیمه ګورو – یوه شېبه صبر وکړئ.",
        "error-body": "ستاسو نوم لیکنه بشپړه شوې. منشي به ستاسو د بیمې مسله له تاسو سره روښانه کړي."
      },
      "insurer-prefilled": {
        "title": "روغتیایي بیمه",
        "subtitle": "مهرباني وکړئ د دې ربع لپاره خپله بیمه تایید کړئ.",
        "your-insurance": "ستاسو بیمه",
        "last-read": "وروستی ځل په {{date}} کې تایید شوی",
        "quarterly-notice": "د بلینګ موخو لپاره، موږ د دې ربع لپاره د بیمې اوسني ثبوت ته اړتیا لرو.",
        "confirm-button": "هو، دا زما بیمه ده",
        "change-button": "زه مختلف بیمه لرم",
        "contact-title": "د پوښښ بریښنایی ثبوت غوښتنه وکړئ",
        "contact-description": "خپلې بیمې ته زنګ ووهئ او د پوښښ بریښنایی ثبوت غوښتنه وکړئ د:",
        "contact-patient": "ناروغ",
        "contact-kim-address": "د ډاکټر دفتر KIM پته",
        "contact-phone": "تلیفون",
        "question": "ایا دا ستاسو روغتیایي بیمه ده؟",
        "quarterly-notice-v2": "په هرو درې میاشتو کې یو ځل د روغتیایي بیمې سند ته اړتیا لرو."
      },
      "insurer-search": {
        "title": "روغتیا بیمه غوره کړئ",
        "subtitle": "مهرباني وکړئ خپله قانوني روغتیا بیمه وپلټئ او وټاکئ.",
        "placeholder": "بيمه ولټوئ...",
        "hint": "د لټون لپاره لږترلږه 2 حروف دننه کړئ.",
        "no-results": "هیڅ بیمه ونه موندل شوه.",
        "no-results-hint": "املا وګورئ یا د بل لټون هڅه وکړئ.",
        "label": "ستاسو د روغتیایي بیمې نوم",
        "search-error-v2": "لټون اوس ونه شو. مهرباني وکړئ بیا هڅه وکړئ.",
        "app-alternative": "د بیمې اپلیکیشن غوره ګڼئ؟"
      },
      "insurer-contact": {
        "title": "د بیمې ثبوت غوښتنه وکړئ",
        "subtitle": "مهرباني وکړئ د لاندې اختیارونو څخه یو غوره کړئ:",
        "or": "یا",
        "option-eeb-title": "په بریښنایی توګه غوښتنه وکړئ",
        "option-eeb-description": "که چیرې قانوني استثنايي حالت شتون ولري، تاسو کولی شئ ستاسو له رضایت وروسته غوښتنه کلینیک ټیم ته وسپارئ.",
        "option-qr-title": "د کاريال سره سکېن کړئ",
        "option-qr-description": "د خپل بیمې ایپ سره د QR کوډ سکین کړئ.",
        "option-call-title": "ځان ته زنګ ووهئ",
        "option-call-description": "خپلې بیمې ته زنګ ووهئ او د دې ډاکټر دفتر لپاره د eEB غوښتنه وکړئ:",
        "phone": "تلیفون",
        "phone-not-available": "ستاسو د بیمې کارت کې د تلیفون شمیره",
        "patient-name": "ناروغ",
        "practice-kim": "د ډاکټر دفتر KIM پته",
        "help-notice": "که تاسو کومه ستونزه لرئ، مهرباني وکړئ د هرکلي میز څخه لیدنه وکړئ.",
        "submit-eeb-button": "اوس غوښتنه وکړئ",
        "contacted-button": "ما زنګ وهلی",
        "contacted-button-countdown": "ستاسو د زنګ لپاره وخت ({{seconds}}s)",
        "go-to-counter-button": "هرکلی ته لاړشئ",
        "qr-continue-button": "ما سکین کړی دی",
        "qr-continue-button-countdown": "د سکین کولو وخت ({{seconds}}s)",
        "title-v2": "ستاسو د روغتیایي بیمې سند",
        "subtitle-v2": "تر ټولو اسانه لار د بیمې اپلیکیشن دی.",
        "subtitle-no-app": "مهرباني وکړئ وټاکئ چې بیمه به سند څنګه موږ ته واستوي.",
        "option-eeb-description-v2": "موږ ستاسو په استازیتوب له بیمې غوښتنه کوو. د دې لپاره ستاسو رضایت ته اړتیا لرو.",
        "call-instruction": "خپلې بیمې ته زنګ ووهئ او وغواړئ چې سند زموږ کلینیک ته واستوي.",
        "call-instruction-practice": "خپلې بیمې ته زنګ ووهئ او وغواړئ چې سند {{practice}} کلینیک ته واستوي.",
        "done-button": "بشپړ – بل",
        "done-button-countdown": "بشپړ – بل ({{seconds}} ثانیې پاتې)"
      },
      "eeb-consent": {
        "title": "رضایت",
        "subtitle": "موږ د بریښنایی بیمې تایید لپاره ستاسو رضایت ته اړتیا لرو.",
        "insurance": "ستاسو بیمه",
        "consent-title": "د بریښنایی بیمې تایید لپاره رضایت (eEB)",
        "consent-text": "زه پوهېږم چې زما روغتیايي بیمه به زما د بیمې معلومات (لکه نوم، د زېږون نېټه، د بیمې شمېره) د خوندي KIM مخابراتي خدمت له لارې کلینیک {{practiceName}} ته د بیمې د ثبوت په توګه ولېږي. زه له دې لېږد سره موافق یم. زه خبر یم چې دا رضایت هر وخت لغوه کولای شم، بې له دې چې زما پر درملنه اغېز وکړي.",
        "withdrawal-notice": "تاسو کولی شئ دا رضایت په هر وخت کې لغوه کړئ.",
        "agree-button": "زه همغږی یم",
        "decline-button": "لغوه کړل",
        "treatment-notice": "ستاسو درملنه د دې رضایت لخوا اغیزمن نه کیږي.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "ستاسو د روغتیایي بیمې سند",
        "summary": "ستاسو بیمه سند مستقیم موږ ته استوي. د دې لپاره ستاسو رضایت ته اړتیا لرو.",
        "confirm-first": "مهرباني وکړئ لومړی اعلامیه تایید کړئ."
      },
      "qr-code": {
        "title": "د بیمې اپلیکیشن سره سکین کړئ",
        "instruction-1": "خپل د بیمې ایپ خلاص کړئ او دا QR کوډ سکین کړئ.",
        "instruction-2": "بیا به د ډاکټر دفتر په اوتومات ډول ستاسو د بیمې تصدیق ترلاسه کړي.",
        "practice": "د ډاکټر دفتر: {{name}}",
        "alternative-hint": "بدیل: خپل د بیمې ایپ وکاروئ",
        "instruction-app": "د خپلې روغتیایي بیمې اپلیکیشن پرانیزئ او دا کوډ سکین کړئ. سند به مستقیم موږ ته راشي.",
        "staff-line": "د کلینیک ټیم لپاره: {{address}}",
        "staff-line-practice": "د کلینیک ټیم لپاره: {{name}} · {{address}}",
        "alternative-app": "تاسو کولی شئ سند د بیمې د اپلیکیشن له لارې هم وغواړئ: اپلیکیشن پرانیزئ او دا کوډ سکین کړئ."
      },
      "register-basics": {
        "title": "وکړيزې خبرتياوې",
        "subtitle": "مهرباني وکړئ خپل جزئیات دننه کړئ.",
        "family-name": "تخلص",
        "given-name": "لومړی نوم",
        "dob": "د زيږون نیټه",
        "gender": "جنس",
        "insurance-type": "د بیمې ډول",
        "insurer-name": "ستاسو د بیمې نوم",
        "insurer-name-placeholder": "د مثال په توګه ډبیکا، DKV، الیانز...",
        "gender-required": "مهرباني وکړئ یو انتخاب وټاکئ."
      },
      "register-insurer": {
        "title": "روغتیایي بیمه",
        "subtitle": "مهرباني وکړئ خپل روغتیا بیمه غوره کړئ.",
        "search-placeholder": "بيمه ولټوئ..."
      },
      "register-details": {
        "title": "لنډيز",
        "subtitle": "مهرباني وکړئ د خپلو معلوماتو بیاکتنه وکړئ.",
        "create": "نوم ثبتونه بشپړه کړه",
        "missing-data": "د مهربانۍ له مخې ټول غوښتى ځایونه ډک کړئ",
        "create-error": "نوم لیکنه ناکامه شوه. مهرباني وکړئ بیا هڅه وکړئ.",
        "policy-number": "د پالیسۍ شمیره (اختیاري)",
        "policy-number-placeholder": "د پالیسي شمېره",
        "create-v2": "نوم لیکنه بشپړه کړئ",
        "policy-number-hint": "شمېره د خپلې بیمې په کارت کې ومومئ."
      },
      "diff-review": {
        "eyebrow-chip": "بياكتل",
        "eyebrow": "چیک ان · د کارت ډېټا",
        "title": "د ډاټا پرتله کول",
        "subtitle": "توپیرونه ستاسو د کارت ډیټا او زموږ ریکارډونو ترمینځ موندل شوي.",
        "col-current": "اوسنی ریکارډ",
        "col-new": "د کارت څخه نوی",
        "new-badge": "نوی",
        "field-fallback": "ډګر",
        "note": "تازه شوي معلومات موږ سره په سمه توګه بل کولو او په عاجل حالت کې تاسو ته په رسیدو کې مرسته کوي.",
        "comparison-placeholder": "پرتله کول به دلته وښودل شي",
        "confirm": "بدلونونه تایید کړئ",
        "apply-error": "ډاټا نشي پلي کیدی. مهرباني وکړئ بیا هڅه وکړئ.",
        "retry": "بیا کوښښ وکړئ.",
        "skip": "پرمخبيول",
        "no-changes": "هیڅ بدلونونه ونه موندل شول",
        "title-v2": "ستاسو معلومات بدل شوي",
        "subtitle-v2": "ستاسو په کارت کې نوي معلومات دي. ایا ومنو یې؟",
        "confirm-v2": "منل او نوم لیکنه",
        "keep": "پرته له بدلون نوم لیکنه",
        "col-current-v2": "مخکې",
        "col-new-v2": "نوی له کارت څخه",
        "value-yes": "هو",
        "value-no": "نه"
      },
      "insurance-selection": {
        "title": "د بیمې ډول",
        "subtitle": "مهرباني وکړئ د خپلې بیمې ډول وټاکئ.",
        "gkv": "د قانون بیمه شوي",
        "gkv-description": "د قانوني روغتیا بیمې غړی.",
        "pkv": "شخصي یا د ځان تادیه",
        "pkv-description": "په خصوصي ډول بیمه شوی یا پخپله تادیه.",
        "pkv-description-v2": "شخصي روغتیایي بیمه، یا تاسو پخپله پیسې ورکوئ."
      },
      "eeb-request": {
        "title": "غوښتنه ثبت شوه",
        "subtitle": "تاسو کولی شئ خپل راجستر بشپړ کړئ. د {{insurer}} ځواب به وروسته کلینیک ته ورسیږي.",
        "verifying": "ستاسو غوښتنه د سمدستي پروسس لپاره ومنل شوه.",
        "success": "ستاسو غوښتنه په خوندي توګه د کلینیک ټیم ته وسپارل شوه.",
        "error": "د غوښتنې تایید شتون نلري.",
        "try-alternative": "بدیل میتود",
        "kim-load-error": "د ډاکټر دفتر KIM پته نشي پورته کیدی.",
        "kim-label": "د ډاکټر دفتر · KIM",
        "non-blocking-note": "دا لا تر اوسه ستاسو د روغتیايي بیمې لخوا ترلاسه کول یا ستاسو د بیمې حالت نه تاییدوي.",
        "auto-continue": "په {{seconds}} ثانیو کې په اتوماتيک ډول مخ ته ځي.",
        "unavailable-title": "له بده مرغه ونه شو",
        "unavailable-v2": "ستاسو غوښتنه روغتیایي بیمې ته ثبت نه شوه.",
        "unavailable-body": "تاسو کولی شئ سند د بیمې د اپلیکیشن له لارې واستوئ یا یې له منشي سره حل کړئ.",
        "use-app": "د اپلیکیشن له لارې",
        "at-reception": "له منشي سره حل"
      },
      "self-pay": {
        "title": "د ځان تادیه",
        "subtitle": "تاسو سره به د ځان معاش ناروغ په توګه چلند وشي.",
        "info": "مهرباني وکړئ په یاد ولرئ چې تاسو به د درملنې لګښتونو مسؤل یاست.",
        "confirm": "دی پرې پوهه شوی دی.",
        "title-v2": "تاسو پخپله پیسې ورکوئ",
        "subtitle-v2": "د درملنې لګښت تاسو پخپله ورکوئ.",
        "insured-after-all": "بیمه لرم"
      },
      "done": {
        "title": "ترسره شو!",
        "subtitle": "ستاسو چیک ان بشپړ شو.",
        "finish": "پای",
        "done-label": "وشو",
        "error-label": "خبرتيا",
        "eyebrow": "چیک ان · بشپړ شوی",
        "queue-label": "د انتظار خونه",
        "queue-title": "مهرباني وکړئ کښینئ",
        "queue-meta": "موږ به تاسو ته په شخصي ډول زنګ ووهو.",
        "success-title": "چیک ان بریالی شو!",
        "success-subtitle": "مهرباني وکړئ د انتظار په خونه کې کښینئ. تاسو ته به زنګ ووهل شي.",
        "auto-redirect": "تاسو به په لنډ وخت کې د پیل پاڼې ته واستول شئ...",
        "auto-redirect-countdown": "د {{seconds}} ثانیو کې پیل کولو لپاره بیرته راستنیدنه...",
        "card-expired-title": "د کارت تاریخ تیر شوی",
        "card-expired-subtitle": "ستاسو د بیمې کارت پای ته رسیدلی.",
        "card-expired-info": "مهرباني وکړئ د مرستې لپاره کارمندانو سره اړیکه ونیسئ.",
        "back-to-start": "بېرته پیل ته",
        "anamnesis-title": "د طبي تاریخ فورمه ډکه کړئ",
        "anamnesis-description": "د QR کوډ سکین کړئ ترڅو خپل طبي تاریخ فورمه په اسانۍ سره ستاسو په سمارټ فون کې ډکه کړئ.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "ستاسو نوم لیکنه وشوه",
        "card-expired-info-v2": "مهرباني وکړئ منشي ته مراجعه وکړئ."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "خپل معلومات وګورئ",
          "balance-prefix": "د خوندي کولو پر وخت:",
          "balance-direct-v2": "سمدستي خوندي کېږي: {{count}}",
          "balance-reception-v2": "منشي یې ګوري: {{count}}",
          "chip-reception-v2": "بدلونونه زموږ منشي ګوري",
          "chip-changed": "بدل شو: {{count}}",
          "remove": "لرې کول",
          "example-email": "د بېلګې په توګه name@example.com",
          "example-phone": "د بېلګې په توګه 0171 1234567",
          "intro-v2": "ستاسو نوم لیکنه بشپړه شوې. ایا دا معلومات لا هم سم دي؟ کتنه اختیاري ده.",
          "auto-hide": "ښودل شوي ارزښتونه له لږ وخت وروسته بیا پټېږي."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "دا معلومات مو منشي ته ورکړل.",
          "banner-done-v2": "مننه! ستاسو معلومات موږ ته ورسېدل.",
          "footer-v2": "نور ټول معلومات همداسې پاتې کېږي."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "د معلوماتو د ساتنې لپاره مو ښودنه وتړله. ستاسو نوم لیکنه بیا هم بشپړه ده. بدلونونه هر وخت منشي ته ویلی شئ."
        }
      },
      "progress": {
        "identify": "نوم لیکنه",
        "insurance": "بیمه",
        "done": "بشپړ"
      },
      "dob-format-hint": "د بېلګې په توګه 01.10.1980",
      "dob-required": "مهرباني وکړئ د زېږون نېټه ولیکئ.",
      "insurance-label": {
        "GKV": "قانوني بیمه",
        "PKV": "شخصي بیمه",
        "SELFPAY": "پخپله تادیه"
      }
    },
    "emergency": {
      "title": "شدید د ژوند ګواښوونکی بیړنی حالت!",
      "label": "بیړنی حالت",
      "subtitle": "دا خبرداری یوازې په همدې ځای کې اورېدل کېږي او مرسته یې نه ده راغوښتې. په حاد یا احتمالي ژوند ګواښوونکي حالت کې 112 ته زنګ ووهئ.",
      "call-emergency": "بیړني خدماتو ته زنګ ووهئ (112)",
      "stop-sound": "غږ بند کړئ",
      "play-sound": "غږ پیل کړئ",
      "back-to-start": "پیل ته ستنېدل",
      "headline": "مهرباني وکړئ سمدستي له منشي کارکوونکو سره خبرې وکړئ. د ژوند د خطر په صورت کې 112 ته زنګ ووهئ."
    },
    "help-reception": "د منشي مرسته",
    "help-reception-toast": "مهرباني وکړئ له منشي سره اړیکه ونیسئ. موږ خوښ یو چې مرسته وکړو.",
    "language-entry": {
      "title": "خپله ژبه وټاکئ"
    },
    "loading": "بارول کېږي…",
    "step-progress-label": "پرمختګ",
    "step-progress-phase": "برخه {{current}} له {{total}}: {{phase}}",
    "step-progress-substep": "څپرکی {{current}} له {{total}}",
    "step-progress-complete": "بشپړ شو",
    "identification": {
      "title": "تاسو څوک یاست؟",
      "lead": "تر ټولو چټکه لار ستاسو د روغتیا بیمې کارت دی. تاسو په خپل نوم هم لټون کولی شئ.",
      "lead-card-only": "مهرباني وکړئ خپل د روغتیا بیمې کارت په کارت لوستونکي کې واچوئ.",
      "mode-label": "څنګه غواړئ ننوځئ؟",
      "mode-card": "په کارت",
      "mode-search": "په نوم لټون",
      "mode-create": "په کلینیک کې نوی",
      "card": {
        "loading": "کارت لوستونکی چمتو کېږي …",
        "checking": "کارت لوستونکی کتل کېږي …",
        "insert-title": "مهرباني وکړئ خپل د روغتیا بیمې کارت په کارت لوستونکي کې واچوئ.",
        "insert-detail": "ستاسو معلومات په اوتومات ډول لولو.",
        "detected": "کارت وپېژندل شو",
        "read": "کارت ولولئ",
        "reading": "کارت لوستل کېږي …",
        "reading-hint": "مهرباني وکړئ کارت په لوستونکي کې پرېږدئ.",
        "no-terminal-title": "کارت لوستونکی شتون نه لري",
        "help-with-search": "مهرباني وکړئ په خپل نوم لټون وکړئ یا له منشي وپوښتئ.",
        "help-reception": "مهرباني وکړئ له منشي وپوښتئ – په خوښۍ مرسته کوو.",
        "unreadable-title": "کارت وپېژندل شو خو نه لوستل کېږي",
        "error-title": "کارت ونه لوستل شو",
        "not-unique": "موږ ونه شو کولی تاسو په ډاډ سره له دې کارت سره سمون کړو. مهرباني وکړئ په خپل نوم لټون وکړئ یا له منشي وپوښتئ.",
        "no-match": "د دې کارت لپاره مو معلومات ونه موندل. مهرباني وکړئ په خپل نوم لټون وکړئ یا له منشي وپوښتئ.",
        "without-card": "پرته له کارت دوام"
      },
      "lookup": {
        "lead": "مهرباني وکړئ خپل تخلص او د زېږون نېټه ولیکئ.",
        "first-name": "نوم",
        "last-name": "تخلص",
        "dob": "د زېږون نېټه",
        "dob-hint": "بڼه: ورځ.میاشت.کال",
        "search": "لټون",
        "confirm": "هو، زه یم",
        "found-title": "تاسو مو وموندئ",
        "found-body": "مهرباني وکړئ تایید کړئ چې دا تاسو یاست.",
        "first-name-needed-title": "مهرباني وکړئ خپل نوم زیات کړئ",
        "first-name-needed-body": "څو تاسو په ډاډ سره ومومو. بیا «لټون» ته ټک ورکړئ.",
        "ambiguous-title": "موږ ونه شو کولی تاسو په ډاډ سره ومومو",
        "ambiguous-body": "مهرباني وکړئ له منشي وپوښتئ – په خوښۍ مرسته کوو.",
        "not-found-title": "ورته معلومات ونه موندل شول",
        "not-found-body": "مهرباني وکړئ خپل لیکلي معلومات وګورئ.",
        "error-title": "لټون اوس ممکن نه دی",
        "error-body": "مهرباني وکړئ بیا هڅه وکړئ یا له منشي وپوښتئ."
      },
      "create": {
        "insurance-question": "تاسو څنګه بیمه یاست؟",
        "insurance-required": "مهرباني وکړئ د خپلې بیمې ډول وټاکئ.",
        "error-title": "ستاسو معلومات خوندي نه شول",
        "error-body": "مهرباني وکړئ بیا هڅه وکړئ یا له منشي وپوښتئ."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "لومړی خلاص کړئ",
      "subtitle": "FrontDesk+ باید ستاسو د تمرین سافټویر کې فعال شي.",
      "step1": "په SolStore کې امر وکړئ (یا ستاسو لپاره ستاسو د Doc-Cirrus شریک امرونه).",
      "step2": "د فعالولو وروسته، په inSuite کې د \"inSuite Sols\" (ادارې حقوق) لاندې فعال کړئ.",
      "step3": "د Bridge اداره پرانیزئ → \"وسیلې اضافه کړئ\".",
      "cta": "ټول ترسره شول - پرمخ لاړ شه"
    },
    "welcome": {
      "title": "دا وسیله تمرین ته اضافه کړئ",
      "scan": "د کوډ عکس واخلئ",
      "prepare-link": "په inSuite کې کوډ نشته؟",
      "language": "ژبه"
    },
    "scan": {
      "requesting": "د کیمرې لاسرسي غوښتنه شوې…",
      "scanning": "کوډ ته کیمره په نښه کړئ",
      "paste": "پرځای یې پیسټ کړئ",
      "manual-title": "په لاسي ډول وصل کړئ",
      "manual-description": "که د QR کوډ شتون ونلري، د Bridge ادارې څخه د ارتباط ډاټا واخلئ.",
      "address-label": "Bridge پته",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "SOLTOKEN داخل کړئ",
      "manual-submit": "پیوستون په غاړه واخلئ",
      "error-title": "کوډ نه پیژندل شوی",
      "camera-denied-title": "کیمرې ته لاسرسی رد شو",
      "camera-denied-hint": "مهرباني وکړئ په ترتیباتو کې د کیمرې لاسرسي ته اجازه ورکړئ او بیا هڅه وکړئ.",
      "retry": "بیا هڅه وکړئ"
    },
    "preflight": {
      "title": "جوړه به شي",
      "all-green": "ټولې ازموینې تیرې شوې",
      "practice": "تمرین",
      "device-name": "د وسیلې نوم",
      "device-name-placeholder": "د مثال په توګه B. استقبال 1",
      "card-reader": "د کارت لوستونکی",
      "pin": "نوی پټ نمبر",
      "pin-placeholder": "څلور عددي PIN",
      "finish": "ختم",
      "recheck": "بیا وګورئ",
      "diagnosis": "د تشخیص ID",
      "checklist-error": "Bridge اړیکه رد کړه یا د لاسرسي وړ نه دی. SOLTOKEN او د Bridge پته وګورئ.",
      "checklist-retry": "بیا وګورئ",
      "edit-token": "SOLTOKEN بدل کړئ",
      "rescan": "کوډ بیا سکن کړئ"
    },
    "persisting": "تنظیمات خوندي کېږي …",
    "success": {
      "title": "وسیله زیاته کړه",
      "detail": "وسیله یوازې په تمرین کمپیوټر کې ښکاره شوې.",
      "starting": "د ناروغ حالت پیل کیږي ..."
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "د تمرین سافټویر سره اړیکه",
        "fix": "Bridge پیوستون او د سرور پته چیک کړئ."
      },
      "missing_insuite_url": {
        "label": "inSuite پته",
        "fix": "د QR کوډ بیا سکین کړئ - پته ورکه ده."
      },
      "missing_server_token": {
        "label": "د سرور نښه",
        "fix": "د QR کوډ بیا سکین کړئ - نښه ورکه ده."
      },
      "missing_gateway_session": {
        "label": "Gateway غونډه",
        "fix": "بیا ننوتل - ناسته ورکه ده."
      },
      "missing_gateway_enrollment": {
        "label": "د وسایلو ثبت کول",
        "fix": "وسیله په Gateway کې راجستر کړئ."
      },
      "gateway_not_ready": {
        "label": "Gateway چمتووالی",
        "fix": "د ترتیب بشپړولو لپاره د Gateway لپاره انتظار وکړئ."
      },
      "token_verification_failed": {
        "label": "د ټوکن چک",
        "fix": "د سرور نښه یا Bridge پیوستون چیک کړئ."
      },
      "session_expired": {
        "label": "غونډه",
        "fix": "ناسته پای ته ورسیده - بیا ننوتل."
      },
      "device_revoked": {
        "label": "د وسیلې حالت",
        "fix": "دا وسیله بنده شوې ده. د تمرین سره اړیکه ونیسئ."
      },
      "missing_practice_name": {
        "label": "د تمرین نوم",
        "fix": "د طبي تمرین نوم نشي پورته کیدی (inSuite)."
      },
      "missing_device_name": {
        "label": "د وسیلې نوم",
        "fix": "مهرباني وکړئ د وسیله نوم ولیکئ."
      },
      "telematik_unavailable": {
        "label": "د ټیلیمیک زیربنا",
        "fix": "اختیاري - د TI شتون سره سم د کارت چیک ممکن پاتې شي."
      },
      "selected_card_reader_unavailable": {
        "label": "د کارت لوستونکی",
        "fix": "اختیاري - د کارت ریډر غوره کړئ یا وصل کړئ."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "اختیاري - د طبي تمرین اعتبار کارت دننه کړئ (SMC-B)."
      }
    },
    "token": {
      "title": "SOLTOKEN دننه کړئ",
      "description": "د امنیتي دلایلو له امله د QR کوډ SOLTOKEN نه لري. دا په inSuite کې د «Sol-Aktivierung» (FrontDesk+) لاندې کاپي کړئ او دلته یې ولګوئ.",
      "submit": "دوام",
      "rescan": "کوډ بیا سکن کړئ"
    }
  }
}
